import { Injectable } from '@angular/core';
import { Vehicle } from '@quorum/models/xs-resource';
import { createEffect } from '@ngrx/effects';
import { DataPersistence } from '@nrwl/angular';
import { ApiService } from '@quorum/api';
import { map } from 'rxjs/operators';
import {
  CreateVehicleOnServer,
  CreateVehicleOnServerSuccess,
  GetVehicleFromServer,
  GetVehicleFromServerSuccess,
  UpdateVehicleOnServer,
  UpdateVehicleOnServerSuccess,
  VehiclesEntityActionTypes,
} from './vehicles.actions';

@Injectable()
export class VehiclesEntityEffects {
  
  getVehicleFromServer = createEffect(() => this.dataPersistence.fetch(VehiclesEntityActionTypes.GetVehicleFromServer, {
    run: (action: GetVehicleFromServer, state: any) => {
      return this.apiService.get<Vehicle>(`v/1/vehicles/vehicles/${action.payload.params.id}`, {}).pipe(
        map((Vehicle) => {
          return new GetVehicleFromServerSuccess(Vehicle);
        })
      );
    },
    onError: (action: GetVehicleFromServer, error) => {
      console.error('Error', error);
    },
  }));

  
  updateVehicleOnServer = createEffect(() => this.dataPersistence.fetch(VehiclesEntityActionTypes.UpdateVehicleOnServer, {
    run: (action: UpdateVehicleOnServer, state: any) => {
      return this.apiService
        .put<Vehicle>(`v/1/vehicles/vehicles/${action.payload.id}`, action.payload, {
          params: { embed: 'associate' },
        })
        .pipe(
          map((Vehicle) => {
            return new UpdateVehicleOnServerSuccess(Vehicle);
          })
        );
    },
    onError: (action: UpdateVehicleOnServer, error) => {
      console.error('Error', error);
    },
  }));

  
  createVehicleOnServer = createEffect(() => this.dataPersistence.fetch(VehiclesEntityActionTypes.CreateVehicleOnServer, {
    run: (action: CreateVehicleOnServer, state: any) => {
      return this.apiService
        .post<Vehicle>(`v/1/vehicles/vehicles`, action.payload, { params: { disableTranslation: true } })
        .pipe(
          map((Vehicle) => {
            return new CreateVehicleOnServerSuccess(Vehicle);
          })
        );
    },
    onError: (action: CreateVehicleOnServer, error) => {
      console.error('Error', error);
    },
  }));

  constructor(private dataPersistence: DataPersistence<any>, private apiService: ApiService) {}
}
